import { FC } from 'react';

import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import Button from '../ThemedButton';

export interface SaveConfirmationProps {
  onConfirm: () => void;
  isOpen: boolean;
  onClose: () => void;
  isLoading: boolean;
  showWarningForContentTemplateLink: boolean;
}

export const SaveConfirmation: FC<SaveConfirmationProps> = ({
  onConfirm,
  isOpen,
  onClose,
  isLoading,
  showWarningForContentTemplateLink = false,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent data-test-id="confirm-save">
        <ModalHeader>Confirm Save</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <p>Are you sure you want to save and redirect to the index page?</p>
          {showWarningForContentTemplateLink && (
            <p style={{ marginTop: '1rem', fontSize: '13px', color: '#c53030' }}>
              The custom image links are missing or have a different format than expected. If this
              was not intended, check the example provided below the content template input{' '}
            </p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            testId="cancelButton"
            muiButtonProps={{
              onClick: onClose,
              color: 'secondary',
              sx: { mr: '1rem' },
            }}
          >
            Cancel
          </Button>
          <Button
            testId="confirm-button"
            isLoading={isLoading}
            muiButtonProps={{
              color: 'primary',
              onClick: onConfirm,
              sx: { minHeight: '36.5px' },
            }}
          >
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
